import React from "react";
import { createRoot } from "react-dom/client";
import SweetAlert from "react-bootstrap-sweetalert";
import colors from "assets/theme/base/colors";

export const showAlert = ({
  title = "",
  message = "",
  type = "info",
  showCancel = false,
  confirmText = "OK",
  cancelText = "Cancel",
  onConfirm = () => {},
  onCancel = () => {},
  confirmColor = colors.deepBlue.main,
  cancelColor = colors.light.main,
  buttonGap = "0.625rem",
}) => {
  const container = document.createElement("div");
  const root = createRoot(container);
  document.body.appendChild(container);

  const cleanup = () => {
    root.unmount();
    container.remove();
  };

  const handleConfirm = () => {
    cleanup();
    onConfirm();
  };

  const handleCancel = () => {
    cleanup();
    onCancel();
  };

  let alertTypeProps = {};
  switch (type) {
    case "success":
      alertTypeProps = { success: true };
      break;
    case "error":
      alertTypeProps = { danger: true };
      break;
    case "warning":
      alertTypeProps = { warning: true };
      break;
    case "info":
    default:
      alertTypeProps = { info: true };
      break;
  }

  root.render(
    <SweetAlert
      {...alertTypeProps}
      showCancel={showCancel}
      title={
        <span
          style={{
            fontSize: "1.5rem",
            lineHeight: "1.3",
            display: "inline-block",
            whiteSpace: "normal",
          }}
        >
          {title}
        </span>
      }
      confirmBtnText={confirmText}
      cancelBtnText={cancelText}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      style={{ width: "28.125rem" }} // control width
      confirmBtnBsStyle="primary" // Bootstrap style required, but we override color below
      cancelBtnBsStyle="secondary"
      customButtons={
        <div
          style={{ display: "flex", justifyContent: "center", gap: buttonGap }}
        >
          {showCancel && (
            <button
              onClick={handleCancel}
              style={{
                fontSize: "1rem",
                backgroundColor: cancelColor,
                color: "#000",
                border: "none",
                padding: " 0.625rem 1rem",
                borderRadius: "0.25rem",
                cursor: "pointer",
              }}
            >
              {cancelText}
            </button>
          )}
          <button
            onClick={handleConfirm}
            style={{
              fontSize: "1rem",
              backgroundColor: confirmColor,
              color: "#fff",
              border: "none",
              padding: " 0.625rem 1rem",
              borderRadius: "0.25rem",
              cursor: "pointer",
            }}
          >
            {confirmText}
          </button>
        </div>
      }
    >
      <div style={{ fontSize: "1.2rem" }}>{message}</div>
    </SweetAlert>,
  );
};
